import React from "react";
import { Grid, Box, Paper } from "@mui/material";
import { Outlet } from "react-router-dom";

const MinimalLayout = ({ maxWidth = 550 }) => (
  <Grid
    container
    direction="column"
    alignItems="center"
    justifyContent="flex-start"
    sx={{ minHeight: "100vh", pt: { xs: 1, sm: 3 } }}
  >
    <Grid item>
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/logo.png`}
        alt="Logo"
        sx={{ width: { xs: 140, sm: 250 }, mb: { xs: 1, sm: 3 } }}
      />
    </Grid>

    <Grid item xs={12} sx={{ px: { xs: 2, sm: 0 } }}>
      <Paper
        elevation={2}
        sx={{
          width: "100%",
          maxWidth,
          p: { xs: 1.4, sm: 2 },
        }}
      >
        <Outlet />
      </Paper>
    </Grid>
  </Grid>
);

export default MinimalLayout;
